import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { ChevronLeftIcon, ChevronRightIcon, CloseIcon } from "@dion-web/ui-icons";
import { isFunction } from "lodash";
import { useCallback } from "react";
import { Stack, Button, Typography } from "../../../..";
import { CALENDAR_VIEW } from "../../model";
import { DatePickerHeader, StackHeaderStyled } from "./index";
const DatePickerHeaderCustom = (props) => {
  const currentMonth = props.currentMonth;
  const monthFormatted = currentMonth.format("MMMM").charAt(0).toUpperCase() + currentMonth.format("MMMM").slice(1);
  const handleViewChange = useCallback((view) => {
    if (!props.onViewChange && !isFunction(props.onViewChange)) {
      console.error("onViewChange method undefined");
      return;
    }
    if (view === props.view)
      props.onViewChange(CALENDAR_VIEW.day);
    props.onViewChange(view);
  }, [props.view, props.onViewChange]);
  const handleViewMonth = useCallback(() => {
    if (props.view === CALENDAR_VIEW.month && !props.views.includes(CALENDAR_VIEW.day))
      return;
    handleViewChange(CALENDAR_VIEW.month);
  }, [props.view, handleViewChange]);
  const handleViewYear = useCallback(() => {
    if (props.view === CALENDAR_VIEW.year && !props.views.includes(CALENDAR_VIEW.day))
      return;
    handleViewChange(CALENDAR_VIEW.year);
  }, [props.view, handleViewChange]);
  const handleMonthDecrease = useCallback(() => props.onMonthChange(currentMonth.add(-1, CALENDAR_VIEW.month), "right"), [currentMonth]);
  const handleMonthIncrease = useCallback(() => props.onMonthChange(currentMonth.add(1, CALENDAR_VIEW.month), "left"), [currentMonth]);
  return /* @__PURE__ */ jsxs(DatePickerHeader, { direction: "row", alignItems: "center", children: [
    props.view === CALENDAR_VIEW.day && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          sx: { marginRight: "auto" },
          variant: "ghost",
          noHover: true,
          size: "s",
          startIcon: /* @__PURE__ */ jsx(ChevronLeftIcon, {}),
          "data-testid": "arrow-previous-month",
          onClick: handleMonthDecrease
        }
      ),
      /* @__PURE__ */ jsxs(Stack, { direction: "row", alignItems: "center", gap: "4px", children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            variant: "secondary",
            size: "s",
            onClick: handleViewMonth,
            children: monthFormatted
          }
        ),
        /* @__PURE__ */ jsx(
          Button,
          {
            variant: "secondary",
            size: "s",
            onClick: handleViewYear,
            children: currentMonth.year()
          }
        )
      ] }),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "ghost",
          noHover: true,
          size: "s",
          startIcon: /* @__PURE__ */ jsx(ChevronRightIcon, {}),
          sx: { marginLeft: "auto" },
          "data-testid": "arrow-next-month",
          onClick: handleMonthIncrease
        }
      )
    ] }),
    (props.view === CALENDAR_VIEW.month || props.view === CALENDAR_VIEW.year) && /* @__PURE__ */ jsxs(StackHeaderStyled, { children: [
      /* @__PURE__ */ jsxs(Typography, { children: [
        " ",
        props.view === CALENDAR_VIEW.month ? "Выбор месяца" : "Выбор года"
      ] }),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "secondary",
          size: "s",
          endIcon: /* @__PURE__ */ jsx(CloseIcon, {}),
          onClick: () => handleViewChange(CALENDAR_VIEW.day)
        }
      )
    ] })
  ] });
};
export {
  DatePickerHeaderCustom
};
